import * as React from "react";
import { WizardState, WizardActionTypes } from "../WizardTypings";
import { CorrectionPreviewModal } from "../../CorrectionPreviewModal";
import Modal, { ModalSize } from "../../../../misc/components/modal";
import { EntityLabelSelector, EntityLabelSelectorForm } from "./EntityLabelSelector";
import { useVisitScheduleCascades } from "../../../Hooks/UseVisitScheduleCascades";
import { VisibleWizards, Correction } from '../../../Request/DcfRequestReducer';
import { useWizard } from '../../../Hooks/UseWizard';
import { Form } from "informed";

export interface EntityLabelCorrectionWizard {
    studyId: string;
    isVisible: boolean;
    originalValue: any;
    subjectIdFieldDisplayText: string;
    onClose: () => void;
    onComplete: (corrections: Array<Correction>) => void;
}

export interface EntityLabel {
    id: string;
    label: string;
}

export interface EntityLabelGroup {
    subject: EntityLabel;
    visit?: EntityLabel;
    session?: EntityLabel;
}

export const EntityLabelCorrectionWizard = ({
    studyId,
    isVisible,
    originalValue,
    subjectIdFieldDisplayText,
    onClose,
    onComplete
}: EntityLabelCorrectionWizard) => {
    const { currentState, dispatch } = useWizard();

    const [selectedVisit, setSelectedVisit] = React.useState(
        null
        //originalValue ? (originalValue.visit ? originalValue.visit.id : null) : null
    );

    const [newLabel, setnewLabel] = React.useState(null);

    const { subjects, visits, sessions, loading } = useVisitScheduleCascades(studyId, originalValue ? originalValue.session.label : null, selectedVisit, originalValue.visit.id);

    if (!isVisible) {
        return null;
    }

    const handleSelectorNext = (form: EntityLabelSelectorForm) => {
        /* There is a bug in our version of informed which stops the onSubmit method from keeping in sync with
                        the state so we have to do the remapping outside of the form here, this has caused alot of the state
                        to be lifted to this component rather than staying in the EntityLabelSelector component */
        setnewLabel({
            subject: form.Subject,
            visit: form.Visit,
            session: form.Session
        });

        dispatch(WizardActionTypes.Next);
    };

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <Form
                    initialValues={
                        {
                            Subject: originalValue.subject.id,
                        } as EntityLabelSelectorForm
                    }
                >
                    <EntityLabelSelector
                        subjectIdFieldDisplayText={subjectIdFieldDisplayText}
                        originalSubjectValue={originalValue.subject}
                        originalVisitValue={originalValue.visit}
                        originalSessionValue={originalValue.session}
                        possibleSubjects={subjects}
                        possibleVisits={visits}
                        possibleSessions={sessions}
                        loading={loading}
                        onVisitChange={id => setSelectedVisit(id)}
                        onNext={form => handleSelectorNext(form)}
                        />
                </Form>
            );
            break;
        case 1:
            const corrections = [
                { sourceCorrection: VisibleWizards.EntityLabels, entity: "Session", field: "SubjectId", oldValue: originalValue.subject.id, newValue: newLabel.subject, },
                { sourceCorrection: VisibleWizards.EntityLabels, entity: "Session", field: "VisitScheduleId", oldValue: originalValue.visit.id, newValue: newLabel.visit },
                { sourceCorrection: VisibleWizards.EntityLabels, entity: "Session", field: "ScheduleItemId", oldValue: originalValue.session.id, newValue: newLabel.session },
            ]

            page = (
                <CorrectionPreviewModal corrections={corrections}
                    miscCorrection={null}
                    onPrev={() => dispatch(WizardActionTypes.Previous)}
                    onNext={() => onComplete(corrections)}
                /> 
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal
            show={true}
            header="Change Subject / Visit or Session Label"
            size={ModalSize.Large}
            closeModalHandler={onClose}
        >
            {page}
        </Modal>
    );
};
